module.exports = __webpack_public_path__ + "img/R8805-PX.b4fe3a3c.jpg";